import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AliCaptcha = _resolveComponent("AliCaptcha")!

  return (_openBlock(), _createElementBlock("div", {
    id: "captcha",
    class: _normalizeClass(_ctx.captchaConfig.config.product === 'bind' ? 'hideHeight' : '')
  }, [
    _createVNode(_component_AliCaptcha, { "captcha-config": _ctx.captchaConfig }, null, 8, ["captcha-config"])
  ], 2))
}